const PURCHASED_CUSTOM_PRINT_STATUS = {
  CUSTOMER_INPUT: 'CUSTOMER_INPUT',
  PENDING: 'PENDING',
  PROCESSING: 'PROCESSING',
  SHIPPED: 'SHIPPED',
  CANCELED: 'CANCELED',
};

const SPECIALTY_PRINTS_PHOTOS_NO = [1, 2, 3, 4, 5];

export { PURCHASED_CUSTOM_PRINT_STATUS, SPECIALTY_PRINTS_PHOTOS_NO };
